import { IconTrophy } from '@tabler/icons-react';
import styled from 'styled-components';

import Row from '@Components/atoms/Row';
import Text from '@Components/atoms/Text';
import { TooltipTrigger } from '@Components/atoms/Tooltip/Tooltip';

interface RootProps {
  readonly isHighlighted: boolean;
}

export const Root = styled.div<RootProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => props.theme.space.xs_4};
  padding: ${(props) => props.theme.space.xs_4} 0.5rem;
  border-radius: 6px;
  background-color: ${(props) => {
    if (props.isHighlighted) {
      return props.theme.palette.table.row.highlight;
    }

    return null;
  }};

  transition:
    border ${(props) => props.theme.transition.theme},
    background-color ${(props) => props.theme.transition.theme};
`;

export const PositionText = styled(Text)`
  min-width: 2.5rem;
  text-align: center;
`;

export const SecondaryText = styled(Text)`
  min-width: 3rem;
`;

export const PrimaryText = styled(Text)`
  min-width: 2rem;
`;

export const MainContainerRow = styled(Row)`
  width: 100%;
  min-width: 0;
`;

export const StyledTooltipTrigger = styled(TooltipTrigger)`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.xs_4};
  width: 100%;
  min-width: 0;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 30px;
  height: 30px;
`;

export const StyledTrophyIcon = styled(IconTrophy)<{ rank: number }>`
  min-width: 2.5rem;

  stroke: ${(props) => {
    switch (props.rank) {
      case 1:
        return props.theme.palette.static.casualMatchPosition.first;
      case 2:
        return props.theme.palette.static.casualMatchPosition.second;
      case 3:
        return props.theme.palette.static.casualMatchPosition.third;
    }
  }};
`;
